import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FormButtons from '../../components/FormButtons';
import InputMoney from '../../components/InputMoney';
import { DescriptionForm } from '../../components/styled';
import useFields from '../../hooks/useFields';
import { formatValuesLoad } from '../index/values';

interface ExpensesProps {
  idRequest: number;
  save: (
    formName: string,
    fields: any,
    isComplete: boolean,
    save: boolean
  ) => void;
  next: () => void;
}

const Expenses = (props: ExpensesProps) => {
  const { idRequest, next, save } = props;
  const [validateForm, setValidateForm] = useState(0);
  const formBse = useSelector((state: any) => state.getFormBse);
  const { formExpenses } = formatValuesLoad(formBse?.data);
  const {
    fields,
    setFieldValue,
    setFieldError,
    formIsValid,
    formIsComplete,
    formIsEmpty
  } = useFields(formExpenses || {});

  if (!formBse?.data) return null;

  const {
    expensesAlquilerHipoteca,
    expensesLuz,
    expensesAgua,
    expensesTelefonoFijo,
    expensesTelefonoCelular,
    expensesCable,
    expensesInternet,
    expensesGas,
    expensesAlimentacion,
    expensesMovilidad,
    expensesSalud,
    expensesPensionUTP,
    expensesPensionEstudiosOtrosFam,
    expensesArticulosAseo,
    expensesVestuarioCalzado,
    expensesPeriodicos,
    expensesDeudas,
    expensesOtros
  } = fields;

  const getProps = () => ({
    setFieldError,
    setFieldValue,
    validateOnStart: idRequest ? idRequest > 0 && !formIsEmpty : false,
    validateForm: formIsEmpty || idRequest === 0 ? 0 : idRequest
  });

  const saveForm = () => {
    setValidateForm(validateForm + 1);
    save('expenses', fields, formIsComplete, true);
  };

  React.useEffect(() => {
    if (idRequest > 0 && !formIsEmpty) {
      save('expenses', fields, formIsComplete, false);
    }
  }, []);
  return (
    <div data-testid="cmp-bse-form-expenses" style={{ padding: '16px 24px' }}>
      <DescriptionForm style={{ color: '#5b36f2' }}>
        Registra los egresos mensuales propios o de tu familia que aplique, caso
        contrario colocar &quot;0&quot;
      </DescriptionForm>
      <InputMoney
        name="expensesAlquilerHipoteca"
        nameLabel="Alquiler o hipoteca"
        value={expensesAlquilerHipoteca}
        {...getProps()}
      />

      <InputMoney
        name="expensesLuz"
        nameLabel="Luz"
        value={expensesLuz}
        {...getProps()}
      />

      <InputMoney
        name="expensesAgua"
        nameLabel="Agua"
        value={expensesAgua}
        {...getProps()}
      />

      <InputMoney
        value={expensesTelefonoFijo}
        name="expensesTelefonoFijo"
        nameLabel="Teléfono fijo"
        {...getProps()}
      />

      <InputMoney
        nameLabel="Teléfono celular"
        value={expensesTelefonoCelular}
        name="expensesTelefonoCelular"
        {...getProps()}
      />

      <InputMoney
        value={expensesCable}
        name="expensesCable"
        nameLabel="Cable"
        {...getProps()}
      />

      <InputMoney
        value={expensesInternet}
        name="expensesInternet"
        nameLabel="Internet"
        {...getProps()}
      />

      <InputMoney
        name="expensesGas"
        nameLabel="Gas"
        value={expensesGas}
        {...getProps()}
      />

      <InputMoney
        value={expensesAlimentacion}
        name="expensesAlimentacion"
        nameLabel="Alimentación"
        {...getProps()}
      />

      <InputMoney
        value={expensesMovilidad}
        name="expensesMovilidad"
        nameLabel="Movilidad general"
        {...getProps()}
      />

      <InputMoney
        value={expensesSalud}
        name="expensesSalud"
        nameLabel="Salud (seguro médico, medicinas, etc.)"
        {...getProps()}
      />

      <InputMoney
        value={expensesPensionUTP}
        name="expensesPensionUTP"
        nameLabel="Pensión UTP"
        {...getProps()}
      />

      <InputMoney
        value={expensesPensionEstudiosOtrosFam}
        name="expensesPensionEstudiosOtrosFam"
        nameLabel="Pensión de estudios de otros familiares"
        {...getProps()}
      />

      <InputMoney
        value={expensesArticulosAseo}
        name="expensesArticulosAseo"
        nameLabel="Artículos de aseo"
        {...getProps()}
      />

      <InputMoney
        value={expensesVestuarioCalzado}
        name="expensesVestuarioCalzado"
        nameLabel="Vestuario y calzado"
        {...getProps()}
      />

      <InputMoney
        value={expensesPeriodicos}
        name="expensesPeriodicos"
        nameLabel="Periódicos y revistas"
        {...getProps()}
      />

      <InputMoney
        value={expensesDeudas}
        name="expensesDeudas"
        nameLabel="Deudas"
        {...getProps()}
      />

      <InputMoney
        value={expensesOtros}
        name="expensesOtros"
        nameLabel="Otros"
        {...getProps()}
      />

      <FormButtons
        handlerSend={saveForm}
        handlerNext={next}
        formIsValid={formIsValid}
      />
    </div>
  );
};

export default Expenses;
